import React from 'react'
import { connect } from 'react-redux'

import { RootState } from 'store'

import { getIsAdmin } from 'models/user/selectors'
import { getDebugSettings } from 'models/admin/selectors'

import AdminProductDetails from 'components/admin/AdminProductDetails'
import type { ProductData } from 'models/furniture'
import type { DebugSettings } from 'models/admin'

interface AdminProductDetailsContainerProps {
    isAdmin: boolean
    productData: ProductData
    debugSettings: DebugSettings
}

const AdminProductDetailsContainer = ({ isAdmin, productData, debugSettings }: AdminProductDetailsContainerProps) => (
    (isAdmin && debugSettings.showProductAdminData) ? <AdminProductDetails productData={productData} /> : null
)

const mapStateToProps = (state: RootState) => ({
    isAdmin: getIsAdmin(state),
    debugSettings: getDebugSettings(state),
})

export default connect(mapStateToProps)(AdminProductDetailsContainer)
